import { ICONS } from '../shared/icons.generated';

interface IconProps {
  /** e.g. "topic:water", "role:steward", "time:morning", "ui:save" */
  name: string;
  size?: number | string;
  /**
   * A vocabulary entry's emoji (contract §1: placeholders until icons are
   * designed). When given it wins over any SVG of the same name, since three
   * demo topic keys (energy, water, health) collide with MCW's artwork.
   */
  emoji?: string | null;
  /** Decorative by default; pass a label when the icon is the only content. */
  title?: string;
  className?: string;
}

/**
 * Renders one of the generated inline SVGs, or an emoji in a box sized like
 * one. An SVG's color comes from CSS `currentColor`, so the same sticky-note
 * artwork works dark-on-pastel inside an event card and pastel-on-dark in the
 * sidebar; an emoji keeps its own colours.
 */
export default function Icon({ name, size = 16, emoji, title, className }: IconProps) {
  if (emoji) {
    // Drawn as SVG text so it scales with `size` exactly as the artwork does, "100%" included.
    return (
      <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        className={className}
        role={title ? 'img' : undefined}
        aria-label={title}
        aria-hidden={title ? undefined : true}
        focusable="false"
        style={{ display: 'block', flexShrink: 0, overflow: 'visible' }}
      >
        {title && <title>{title}</title>}
        <text x="50" y="54" fontSize="82" textAnchor="middle" dominantBaseline="central">
          {emoji}
        </text>
      </svg>
    );
  }
  const icon = ICONS[name];
  if (!icon) return null;
  return (
    <svg
      viewBox={icon.viewBox}
      width={size}
      height={size}
      className={className}
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
      style={{ display: 'block', flexShrink: 0, overflow: 'visible' }}
      dangerouslySetInnerHTML={{ __html: title ? `<title>${title}</title>${icon.body}` : icon.body }}
    />
  );
}
